import type { Tables } from "@/integrations/supabase/types";
import { tryList, toQueryString } from "./_shared";

export type ApiLog = Tables<"api_logs">;

export interface ApiLogFilters {
  method?: string;
  endpoint?: string;
  limit?: number;
}

export interface ApiLogWithKeyName extends ApiLog {
  api_key_name: string;
}

export interface CompanyApiLogFilters extends ApiLogFilters {
  apiKeyId?: string;
  dateRangeStart?: Date;
}

export const apiLogService = {
  listByApiKey(apiKeyId: string, filters: ApiLogFilters = {}) {
    return tryList<ApiLog>(
      `/api/api-logs${toQueryString({
        apiKeyId,
        method: filters.method && filters.method !== "all" ? filters.method : undefined,
        endpoint: filters.endpoint,
        limit: filters.limit,
      })}`,
    );
  },
  listByCompany(_companyId: string, filters: CompanyApiLogFilters = {}) {
    return tryList<ApiLogWithKeyName>(
      `/api/api-logs${toQueryString({
        apiKeyId: filters.apiKeyId,
        method: filters.method && filters.method !== "all" ? filters.method : undefined,
        endpoint: filters.endpoint,
        limit: filters.limit,
        dateRangeStart: filters.dateRangeStart?.toISOString(),
      })}`,
    );
  },
};
